"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownWrapper = exports.dropdownStyle = exports.DropdownSelectedItem = exports.DropdownLabel = exports.PaneTitle = exports.PaneTitlePositionStyle = exports.PaneTitleTextStyle = void 0;
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const LayoutStyles_1 = require("./LayoutStyles");
exports.PaneTitleTextStyle = {
    color: widgets_1.TabStyles.Typography.Color.Primary,
    fontSize: '15px', // This size is not in TabStyles. This matches the subplace tabs from VizPortal.
};
exports.PaneTitlePositionStyle = {
    height: widgets_1.TabStyles.Sizing.RowHeight,
    lineHeight: `${widgets_1.TabStyles.Sizing.RowHeight}px`,
    paddingLeft: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    paddingRight: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
    paddingBottom: widgets_1.TabStyles.Spacing.SmallSpace,
};
exports.PaneTitle = (0, vizportalclient_common_components_1.divWithStyle)('PaneTitle', [exports.PaneTitleTextStyle, exports.PaneTitlePositionStyle]);
exports.DropdownLabel = (0, vizportalclient_common_components_1.divWithStyle)('DropdownLabel', [exports.PaneTitleTextStyle, exports.PaneTitlePositionStyle, {
        paddingTop: widgets_1.TabStyles.Spacing.LargeSpace,
        paddingBottom: widgets_1.TabStyles.Spacing.DefaultSpace,
    }]);
exports.DropdownSelectedItem = (0, vizportalclient_common_components_1.divWithStyle)('DropdownSelectedItem', LayoutStyles_1.elideTextStyle);
exports.dropdownStyle = {
    maxWidth: 300,
};
exports.DropdownWrapper = (0, vizportalclient_common_components_1.divWithStyle)('DropdownWrapper', {
    paddingLeft: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    paddingBottom: widgets_1.TabStyles.Spacing.LargeSpace,
});
//# sourceMappingURL=SubplaceStyles.js.map